<template>
  <div class="animated fadeIn" id="tab-clotures">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i>
        <strong>Historique des Clotures</strong>
        <vue-excel-xlsx
          :data="excelData"
          :columns="excelColumns"
          class="btn btn-success mr-1 pull-right"
          filename="export_clotures">
          <i class="fa fa-file-excel-o"></i>&nbsp; Exporter en Excel
        </vue-excel-xlsx>
      </b-card-header>
      <b-card-body>
        <v-client-table :columns="columns" :data="items" :options="options">
          <div v-if="props.row.date_enregistrement" slot="date_enregistrement" slot-scope="props" class="slot-date">
            <span class="badge badge-success p-2">{{ formatDate(props.row.date_enregistrement) }}</span>
          </div>
          <div slot="total_virement" slot-scope="props" class="slot-number">{{ formatNumber(props.row.total_virement) }}</div>
          <div slot="nb_virement" slot-scope="props" class="slot-number">{{ props.row.nb_virement }}</div>
          <div slot="total_telereglement" slot-scope="props" class="slot-number">{{ formatNumber(props.row.total_telereglement) }}</div>
          <div slot="nb_telereglement" slot-scope="props" class="slot-number">{{ props.row.nb_telereglement }}</div>
          <div slot="total_cheque" slot-scope="props" class="slot-number">{{ formatNumber(props.row.total_cheque) }}</div>
          <div slot="nb_cheque" slot-scope="props" class="slot-number">{{ props.row.nb_cheque }}</div>
          <div slot="total_global" slot-scope="props" class="slot-number"><strong>{{ formatNumber(props.row.total_global) }}</strong></div>
          <div slot="nb_global" slot-scope="props" class="slot-number"><strong>{{ props.row.nb_global }}</strong></div>
        </v-client-table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '../../utils/auth'
import {espaceRPARules, hasRule} from '../../utils/rulesHelper'

export default {
  data() {
    return {
      rules: espaceRPARules,
      columns: [
        "date_enregistrement",
        "total_virement",
        "nb_virement",
        "total_telereglement",
        "nb_telereglement",
        "total_cheque",
        "nb_cheque",
        "total_global",
        "nb_global"

      ],
      items: [],
      options: {
        headings: {
          date_enregistrement: "Date",
          total_virement: "Montant virement",
          nb_virement: "Nb virement",
          total_telereglement: "Montant télérèglt",
          nb_telereglement: "Nb télérèglement",
          total_cheque : "Montant chèque",
          nb_cheque: "Nb chèque",
          total_global : "Montant Total",
          nb_global : "Nb total"

        },
        sortable: ["date_enregistrement", "total_virement", "total_telereglement","total_cheque","total_global"],
        filterable: ["total_virement", "total_telereglement", "total_cheque", "total_global"],
        perPage: 30,
        perPageValues: [30, 100, 300],
        texts: {
          filterPlaceholder: "Montant"
        }
      },
      excelColumns : [
        {
          label: "Date",
          field: "date_enregistrement",
        },
        {
          label: "Montant Encaissé virement",
          field: "total_virement",
        },
        {
          label: "Nbre virement traités",
          field: "nb_virement",
        },
        {
          label: "Montant Encaissé télérèglement",
          field: "total_telereglement",
        },
        {
          label: "Nbre télérèglement traités",
          field: "nb_telereglement",
        },
        {
          label: "Montant Encaissé chèque",
          field: "total_cheque",
        },
        {
          label: "Nbre chèque traités",
          field: "nb_cheque",
        },
        {
          label: "Montant Encaissé global",
          field: "total_global",
        },
        {
          label: "Nbre global traités",
          field: "nb_global",
        },
      ],
      excelData : [],
    }
  },
  mounted() {
   this.all();
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
    this.$axios.defaults.headers.common["Accept"] = "application/json";
    this.$axios.defaults.headers.common["Provider"] = getProvider();
  },
  methods: {
    canAccess(rule) {
      return hasRule(rule)
    },
    formatNumber(num) {
      if(num != null){
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ").replace(/\./g, ",");
      }
    },
    formatDate(textDate) {
      let date = textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
      return date;
    },
    all() {
      let self = this;
      this.$store.commit("IS_LOADING", true);
      this.$axios
        .get("/espaceRPA/clotures")
        .then(response => {
          this.excelData = [];
          this.$store.commit("IS_LOADING", false);
          this.items = response.data.clotures;
          for(let item of response.data.clotures) {
            this.excelData.push({
              date_enregistrement: this.formatDate(item.date_enregistrement),
              total_virement: item.total_virement && this.formatNumber(item.total_virement),
              nb_virement: item.nb_virement,
              total_telereglement: item.total_telereglement && this.formatNumber(item.total_telereglement),
              nb_telereglement: item.nb_telereglement,
              total_cheque: item.total_cheque && this.formatNumber(item.total_cheque),
              nb_cheque: item.nb_cheque,
              total_global: item.total_global && this.formatNumber(item.total_global),
              nb_global: item.nb_global,
            });
          }
        })
        .catch(function(error) {
          self.$store.commit("IS_LOADING", false);
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
            showConfirmButton: false,
            timer: 5000
          });
        });
    },
  }
}
</script>


<style>
  #tab-clotures .VueTables__table thead tr th:first-child {
    width: 10%;
  }
  #tab-clotures .VueTables__table thead tr th:nth-child(2) {
    width: 10%;
  }
  #tab-clotures .VueTables__table thead tr th:nth-child(3) {
    width: 10%;
  }
  #tab-clotures .VueTables__table thead tr th:nth-child(4) {
    width: 10%;
  }
  #tab-clotures .VueTables__table thead tr th:nth-child(5) {
    width: 10%;
  }
  #tab-clotures .VueTables__table thead tr th:nth-child(6) {
    width: 10%;
  }
  #tab-clotures .VueTables__table thead tr th:nth-child(7) {
    width: 10%;
  }
  #tab-clotures .VueTables__table thead tr th:nth-child(8) {
    width: 10%;
  }
  #tab-clotures .VueTables__table thead tr th:nth-child(9) {
    width: 10%;
  }
</style>
